'use client';
import { CatButton } from 'components/blocks-components';
import { CatIconFilterLines } from 'blocks-nextjs/blocks-react/components/Icons/FilterLines';
import { useFilterAndSortDrawer } from '../filter-and-sort-drawer-context/filter-and-sort-drawer-context';
import { useTranslations } from 'next-intl';
import styles from './filter-and-sort.-button.module.scss';
import cx from 'classnames';
import { getSelectedFacetCount } from './utils';

export const FilterAndSortButton = ({
  isRedesignFilter,
  facets,
  className
}: {
  isRedesignFilter: boolean;
  facets?: string | string[];
  className?: string;
}) => {
  const { openDrawer } = useFilterAndSortDrawer();
  const t = useTranslations();

  const buttonVariant = isRedesignFilter ? null : 'ghost';
  const buttonText = isRedesignFilter ? 'GO_BUTTON' : `FILTER_AND_SORT`;
  const selectedFacetCount =
    facets?.length > 0 ? ` (${getSelectedFacetCount(facets)})` : '';

  return (
    <CatButton
      variant={buttonVariant}
      onClick={openDrawer}
      fullWidth={isRedesignFilter}
      className={cx(
        {
          [styles['filter-and-sort__btn']]: !isRedesignFilter,
          [styles['filter-and-sort__btn--active']]:
            isRedesignFilter && !!selectedFacetCount
        },
        className
      )}
      data-testid="filter-and-sort-button"
    >
      <span
        className={cx(
          'd-flex align-items-center',
          styles['filter-and-sort__trigger-container']
        )}
      >
        {isRedesignFilter && <CatIconFilterLines />}
        {`${t(buttonText)}${selectedFacetCount}`}
        {!isRedesignFilter && <CatIconFilterLines />}
      </span>
    </CatButton>
  );
};
